import { FlexRowCenter, OverflowText } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import React from "react";

interface DividerWithStatusProps {
	/* Divider name */
	name: string;

	/* The status label on the right side */
	statusLabelRes: string;

	/* Text color of status label */
	textColor: string;
}

export const DividerWithStatus = (props: DividerWithStatusProps) => {
	const { name, statusLabelRes, textColor } = props;

	return (
		<FlexRowCenter
			flexGrow={1}
			justifyContent="space-between"
			p={1}
			sx={{
				backgroundColor: grey[200],
			}}
		>
			<OverflowText
				bold
				text={name}
			/>
			<OverflowText
				color={textColor}
				res={statusLabelRes}
			/>
		</FlexRowCenter>
	);
};